import CheckPermission from '../helpers/Administradores/Permissions';
import PackageRequestsContent from '../components/Prestaciones/packages/PackageRequestsContent';

const AprobacionesPaqueteScreen = () => {
  if (!CheckPermission('Prestaciones.Paquetes.Aprobar')) {
    return (
      <div style={{ padding: 40, fontFamily: 'Roboto', color: '#555' }}>
        No tienes permisos para ver las aprobaciones de paquete.
      </div>
    );
  }

  return <PackageRequestsContent />;
};

export default AprobacionesPaqueteScreen;
